
import {Component, Mixins, Prop} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import RaporQueryBuilderSimple from "@/components/inputs/RaporQueryBuilderSimple.vue";
import {RaporAlanEntity} from "@/entity/RaporAlanEntity";
import {RaporKosulEntity} from "@/entity/RaporKosulEntity";
import RaporKosulGrupEntity from "@/entity/RaporKosulGrupEntity";

@Component({
  name: "RaporQueryBuilderGroup",
  components: {RaporQueryBuilderSimple}
})
export default class RaporQueryBuilderGroup extends Mixins(ObjectInputMixin) {
  @Prop({}) raporAlanlari!: Array<RaporAlanEntity>;
  localValue: RaporKosulGrupEntity = new RaporKosulGrupEntity();

  get kosulVerilebilirAlanlar(): Array<RaporAlanEntity> {
    return (this.raporAlanlari || []).filter((a: any) => (a.kosul_operatorleri || []).length > 0);
  }

  veMiSec(deger: boolean) {
    this.$set(this.localValue, "ve_mi", deger);
    this.input();
  }

  kosulEkle() {
    if (!this.localValue.kosullar) this.$set(this.localValue, "kosullar", []);
    const yeni = new RaporKosulEntity();
    const ilk: any = this.kosulVerilebilirAlanlar[0];
    if (ilk) yeni.rapor_alan_id = ilk.id;
    this.localValue.kosullar.push(yeni);
    this.input();
  }

  kosulGrubuEkle() {
    if (!this.localValue.kosullar) this.$set(this.localValue, "kosullar", []);
    this.localValue.kosullar.push({ve_mi: true, kosullar: []});
    this.input();
  }

  kosulSil(index: number) {
    this.localValue.kosullar.splice(index, 1);
    this.input();
  }
}
